import * as Mod1 from "./discourse/discourse-workflows-public-route-map";
import * as Mod2 from "./discourse/initializers/admin-plugin-configuration-nav";
import * as Mod3 from "./discourse/initializers/post-button-workflows";
import * as Mod4 from "./discourse/initializers/topic-admin-button-workflows";
import * as Mod5 from "./discourse/initializers/workflow-webhook-links";
import * as Mod6 from "./discourse/initializers/workflows-user-modal";
import * as Mod7 from "./discourse/pre-initializers/workflow-transformers";
import * as Mod8 from "./discourse/services/workflows-node-types";
const compatModules = {
  "discourse/discourse-workflows-public-route-map": Mod1,
  "discourse/initializers/admin-plugin-configuration-nav": Mod2,
  "discourse/initializers/post-button-workflows": Mod3,
  "discourse/initializers/topic-admin-button-workflows": Mod4,
  "discourse/initializers/workflow-webhook-links": Mod5,
  "discourse/initializers/workflows-user-modal": Mod6,
  "discourse/pre-initializers/workflow-transformers": Mod7,
  "discourse/services/workflows-node-types": Mod8,
};
const pluginExports = {
};
export const routes = [
  { names: ["workflows-form","workflows-form-test"], load: () => import("virtual:route:main:workflows-form") },
];
export { compatModules };
export default pluginExports;
